import React, { CSSProperties } from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';


import IActions from 'icons/IActions';

export type CheckButtonProps = ButtonProps & {
  onlyIcon?: boolean;
  style?: CSSProperties;
};

const ButtonAction = ({
  children = 'Upload',
  onlyIcon = false,
  style,
  ...otherProps
}: CheckButtonProps) => {
  return (
    <Button icon={<IActions twoToneColor="Green" />} style={style??{ height: 40 }} {...otherProps}>
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default ButtonAction;

